function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.1,11.7c-0.2-1.1-0.4-2.2-0.6-3.3S14,6.9,12.8,6.7l-4-4.1c-0.2-0.2-0.5-0.2-0.7,0c0,0,0,0,0,0H8L6.8,3.9l2.4,2.4 c0.3,0.3,0.3,0.8,0,1.1c-0.3,0.3-0.8,0.3-1.1,0l0,0L5.7,4.9l-5.6,5.6C0,10.7,0,11,0.1,11.2c0,0,0,0,0,0l0,0l5.4,5.4 c0.2,0.2,0.5,0.2,0.7,0L14,8.8c0.2-0.2,0.2-0.5,0-0.7c0.1-0.1,0.2,0,0.3,0c0,0,0,0,0,0l0,0c0.3,0.9,0.2,2-0.3,2.8 c-0.3,0.5-0.6,1-0.7,1.6c-0.1,0.7,0.4,1.3,1.1,1.4h0.3C15.6,14,16.2,13.2,16.1,11.7z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.8,3.9L3.9,1C3.6,0.7,3.1,0.8,2.9,1.1C2.6,1.4,2.6,1.8,2.9,2l2.9,2.9L6.8,3.9z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.8,17.5h-0.9v-0.9h0.5v-0.5h0.9V17C22.3,17.3,22.1,17.5,21.8,17.5C21.9,17.5,21.8,17.5,21.8,17.5z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.3,17.5h-1.6v-0.9h1.6L19.3,17.5z M16,17.5h-1.6v-0.9H16V17.5z M12.7,17.5h-1.6v-0.9h1.6V17.5z M9.5,17.5H7.8v-0.9h1.6 L9.5,17.5z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M19.3,0.9h-1.6V0h1.6L19.3,0.9z M16,0.9h-1.6V0H16V0.9z M12.7,0.9h-1.6V0h1.6V0.9z M9.4,0.9H7.8V0h1.6V0.9z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M22.3,1.4h-0.9V0.9h-0.5V0h0.9c0.3,0,0.5,0.2,0.5,0.5V1.4z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M22.3,14.5h-0.9v-1.6h0.9V14.5z M22.3,11.2h-0.9V9.6h0.9V11.2z M22.3,7.9h-0.9V6.3h0.9V7.9z M22.3,4.7h-0.9V3h0.9V4.7z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M18.9,5.4c-0.1,0-0.2-0.1-0.3-0.1L17,3.7c-0.1-0.2-0.1-0.5,0.1-0.6c0.2-0.1,0.4-0.1,0.5,0l1.6,1.6c0.2,0.2,0.2,0.5,0,0.7 C19.2,5.3,19,5.4,18.9,5.4z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7,8.5c-0.1,0-0.2,0-0.3-0.1L14,3.9c-0.2-0.2-0.2-0.5,0-0.6c0.2-0.2,0.5-0.2,0.6,0c0,0,0,0,0,0L19,7.7 c0.2,0.2,0.2,0.5,0,0.7C18.9,8.4,18.8,8.5,18.7,8.5z"
});

var SvgWindowIcon = function SvgWindowIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22.7 17.5",
    style: {
      enableBackground: "new 0 0 22.7 17.5"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWindowIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/WindowIcon.61684614.svg";
export { ForwardRef as ReactComponent };